export enum SpecialtyGroupExceptionStatus {
  None = "none",
  Pending = "pending",
  Submitted = "submitted",
  Approved = "approved",
  Denied = "denied",
  Appealed = "appealed",
  Archived = "archived",
  Expired = "expired",
}

export enum SpecialtyGroupExceptionGrade {
  None = "none",
  A = "a",
  B = "b",
  C = "c",
}

export enum SpecialtyGroupExceptionReviewStatus {
  None = "none",
  NotReady = "notReady",
  ReadyForReview = "readyForReview",
  ReadyForSubmission = "readyForSubmission",
}

export enum SortExceptionColumn {
  DateUpdated = "dateUpdated",
  CustomProjectName = "customProjectName",
  ServiceArea = "serviceArea",
  RegionSetStatus = "regionSetStatus",
  Specialty = "specialty",
  GapResolutionStatus = "gapResolutionStatus",
  Grade = "grade",
  StartDate = "startDate",
  EndDate = "endDate",
  SpecialtyGroupExceptionStatus = "specialtyGroupExceptionStatus",
  PreviouslyApproved ="previouslyApproved",
  HasComments = "hasComments",
  HasNarrative = "hasNarrative",
  ProcessingStatus = "processingStatus",
  UpdatedByUserFullName = "updatedByUserFullName",
  MetOverall = "metOverall",
  LineOfBusiness = "lineOfBusiness",
  HasUnprocessedExcludedProviders = "hasUnprocessedExcludedProviders",
  ReviewStatus = "ReviewStatus",
}

export enum ExceptionDocumentType {
  CMS = "CMS",
  CCIIO = "CCIIO",
}

export enum CciioNewProviderFrequency {
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly",
  EveryOtherMonth = "everyOtherMonth",
  Quarterly = "quarterly",
}

export const SpecialtyGroupExceptionReviewStatusLabels: Record<SpecialtyGroupExceptionReviewStatus, string> = {
  [SpecialtyGroupExceptionReviewStatus.None]: "Select a status",
  [SpecialtyGroupExceptionReviewStatus.NotReady]: "Not Ready",
  [SpecialtyGroupExceptionReviewStatus.ReadyForReview]: "Ready for Review",
  [SpecialtyGroupExceptionReviewStatus.ReadyForSubmission]: "Ready for Submission",
};

export const SpecialtyGroupExceptionStatusLabels: Record<SpecialtyGroupExceptionStatus, string> = {
  [SpecialtyGroupExceptionStatus.Appealed]: "Appealed",
  [SpecialtyGroupExceptionStatus.Approved]: "Approved",
  [SpecialtyGroupExceptionStatus.Archived]: "Archived",
  [SpecialtyGroupExceptionStatus.Denied]: "Denied",
  [SpecialtyGroupExceptionStatus.Expired]: "Expired",
  [SpecialtyGroupExceptionStatus.None]: "None",
  [SpecialtyGroupExceptionStatus.Pending]: "Pending",
  [SpecialtyGroupExceptionStatus.Submitted]: "Submitted",
};
